import { useT } from '@transifex/react';
import { useState } from 'react';

import type { CreateChildAccountPayload } from 'pkg/actions/accounts';

import * as actions from 'pkg/actions';
import { useCurrentAccount } from 'pkg/identity';
import { useAccountIdentity } from 'pkg/identity/account';

import type { FormPayload } from 'components/form/Form';
import Form, { asString } from 'components/form/Form';
import { useJoinModalContext } from 'components/group/join-modal';
import { FormItems } from 'components/group/join-modal/create-ward/form_items';

import Button from 'design/button';

export function CreateWard() {
	const t = useT();
	const [showForm, setShowForm] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const currentAccount = useCurrentAccount();
	const { refreshAccountIdentity } = useAccountIdentity();
	const { setAll } = useJoinModalContext();

	const toggleForm = () => setShowForm(!showForm);

	const handleSubmit = async (data: FormPayload) => {
		setIsSubmitting(true);

		const payload: CreateChildAccountPayload = {
			firstName: asString(data.firstName),
			lastName: asString(data.lastName),
			birthDate: asString(data.dateOfBirth),
			countryCode: currentAccount.countryCode,
			languageCode: currentAccount.languageCode,
		};

		if (data.createAccount) {
			payload.email = asString(data.email);
			payload.password = asString(data.password);
		}

		const [ok, account] = await actions.accounts.createChildAccount(
			currentAccount.id,
			payload
		);

		if (ok) {
			await refreshAccountIdentity();
			setAll({ targetAccount: account });
			toggleForm();
		}

		setIsSubmitting(false);
	};

	if (showForm) {
		return (
			<Form onSubmit={handleSubmit}>
				<FormItems isSubmitting={isSubmitting} toggleForm={toggleForm} />
			</Form>
		);
	}

	return (
		<Button label={t('Add/Create child')} icon="add" onClick={toggleForm} />
	);
}
